// Component: social-share copy-link handler
// Event delegation pattern — single global listener handles all current and future copy buttons.
// Loaded conditionally by social-share.liquid when settings.share_copy_link is enabled.

(function () {
  if (window.__socialShareCopyHandlerBound) return;
  window.__socialShareCopyHandlerBound = true;

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-copy-url]');
    if (!btn) return;
    e.preventDefault();

    const url = btn.dataset.copyUrl;
    if (!url) return;

    try {
      await navigator.clipboard.writeText(url);
      btn.classList.add('is-copied');
      setTimeout(() => btn.classList.remove('is-copied'), 1500);
      if (window.theme?.utilities?.announce) {
        window.theme.utilities.announce(window.theme?.strings?.copy_link_success || 'Link copied');
      }
    } catch (err) {
      window.prompt('Copy this link:', url);
    }
  });
})();
